import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

const buildRecommendationURL = (groupId) => buildUrl(`/groups/${groupId}/skill-recommendations`);
const method = 'GET';

export const FETCH_SKILL_RECOMMENDATION_REQUEST = 'FETCH_SKILL_RECOMMENDATION_REQUEST';
export const FETCH_SKILL_RECOMMENDATION_SUCCESS = 'FETCH_SKILL_RECOMMENDATION_SUCCESS';
export const FETCH_SKILL_RECOMMENDATION_FAILURE = 'FETCH_SKILL_RECOMMENDATION_FAILURE';

export function fetchSkillRecommendationsIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method, url: buildRecommendationURL(groupId) })) {
      return false;
    }

    return dispatch(fetchSkillRecommendations(groupId));
  };
}

export function fetchSkillRecommendations(groupId) {
  return (dispatch) => {
    const url = buildRecommendationURL(groupId);

    return dispatch(fetchSkillRecommendationsRequest()).payload
      .then((response) => dispatch(fetchSkillRecommendationsSuccess(response)))
      .catch((error) => dispatch(fetchSkillRecommendationsFailure(error)));

    function fetchSkillRecommendationsRequest() {
      return ApiCall.createAction({
        type: FETCH_SKILL_RECOMMENDATION_REQUEST,
        payload: fetch(url),
        url,
        method,
      });
    }

    function fetchSkillRecommendationsSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_SKILL_RECOMMENDATION_SUCCESS,
        payload: response,
        url,
        method,
        groupId,
      });
    }

    function fetchSkillRecommendationsFailure(error) {
      return ApiCall.createAction({
        type: FETCH_SKILL_RECOMMENDATION_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/SkillRecommendation/actions.js